
$('input[type="checkbox"][data-toggle-visibility]').each(function () {
    const selector = '#' + $(this).data('toggleVisibility');
    const toggleElements = $(selector + ', label[for="' + $(this).data('toggleVisibility') + '"]');
    const toggleElementInputs = $(selector + ' input, input' + selector);

    if (!$(this).is(':checked')) {
        toggleElements.hide();
    }

    $(this).on('click', function () {
        if ($(this).is(':checked')) {
            toggleElements.show();
            toggleElementInputs.filter('[data-required-if-visible]').attr('required', true);
        } else {
            toggleElements.hide();
            toggleElementInputs.attr('required', false);
        }
    });
});
